import { authClient } from '~~/layers/base/lib/auth-client'
import { isDeviceOffline } from '~~/layers/base/utils/isDeviceOffline'
import { isEcommerceDesignerPath } from '~~/layers/base/utils/isEcommerceDesignerRoute'

type DatadogLogger = {
    logError: (error: Error, context: Record<string, unknown>) => void
}

/**
 * Ensures a guest Better Auth session exists (anonymous sign-in when no user).
 * Skips on ecommerce designer paths during the TK-13530 injunction (Magento/ACCS owns identity).
 */
export async function ensureGuestBetterAuthSession(datadog?: DatadogLogger): Promise<void> {
    if (import.meta.server) {
        return
    }
    if (typeof window !== 'undefined' && isEcommerceDesignerPath(window.location.pathname)) {
        return
    }
    if (await isDeviceOffline()) {
        return
    }

    const session = await authClient.getSession()
    if (session.data?.user) {
        return
    }

    const result = await authClient.signIn.anonymous()
    if (result.error && datadog) {
        datadog.logError(new Error(result.error.message), {
            feature: 'better-auth',
            action: 'signIn.anonymous',
            phase: 'guest-bootstrap',
        })
    }
}
